<template>
    <div>
        <div class="title">
            Test List Form
        </div>
        <v-card>
            <div class="card-container">
                <v-text-field v-model="testList.name" clearable class="form-field" background-color="white" label="Test List Name" />
                <v-data-table
                    :headers="headers"
                    :items="transformArray(testList.recipients)"
                    class="form-field"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Recipients</v-toolbar-title>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            />
                            <v-spacer />
                        </v-toolbar>
                        <div class="add-row-container">
                            <v-text-field
                                v-model="newItem"
                                class="phone-input"
                                label="Phone Number"
                            />
                            <v-btn
                                color="primary"
                                @click="addRow"
                            >
                                Add Recipient
                            </v-btn>
                        </div>
                    </template>
                    <template v-slot:item.actions="{ item, index }">
                        <v-icon
                            color="red"
                            depressed
                            class="mr-2"
                            @click="deleteRow(index)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </div>
            <div class="text-center">
                <v-btn class="edit-btn" @click="createTestList">
                    Create Test List
                </v-btn>
            </div>
        </v-card>
        <alert :show-alert="showAlert" :message="alertMessage" :type="alertType" />
    </div>
</template>

<script>
    import testListService from '@/services/test-list-service'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { Alert },
        data() {
            return {
                testList: {
                    name: '',
                    recipients: []
                },
                headers: [
                    { text: 'Phone Number', value: 'value' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                newItem: '',
                showAlert: false,
                alertMessage: '',
                alertType: 'error'
            }
        },
        watch: {
            showAlert: {
                handler(newval) {
                    if (newval) {
                        setTimeout(() => { this.showAlert = false }, 3000)
                    }
                }
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.alertMessage = message
                this.alertType = type
            },
            addRow() {
                const regex = /^(30\d{10}|69\d{8})$/
                if (this.newItem && regex.test(this.newItem)) {
                    this.testList.recipients.push(`${this.newItem}`)
                    this.newItem = ''
                }
            },
            deleteRow(index) {
                this.testList.recipients.splice(index, 1)
            },
            transformArray(array) {
                return array.map(item => ({ value: item }))
            },
            createTestList() {
                const testList = {
                    name: this.testList.name,
                    recipients: this.testList.recipients
                }
                testListService.createTestList(testList).then(() => {
                    this.setAlert('Test List Entry Created', 'success')
                    setTimeout(() => {
                        this.$router.push('/test-list')
                    }, 1000)
                }).catch(error => {
                    this.setAlert(error.response.data.message, 'error')
                })
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding: 15px;
}

.phone-input {
    max-width: 30%;
    margin-right: 5%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 5px;
    width: 99%;
}

.add-row-container {
    display: flex;
    justify-content: start;
    align-items: center;
}

</style>
